import type {AiChatCopyImageSource} from '@Libraries/ga-events';

export const COPY_FEEDBACK_DURATION_MS = 2000;

export const COPY_IMAGE_FAILED_GROWL_KEY = 'aiChatCopyImageFailed';

export const COPY_IMAGE_FAILED_GROWL_INTERVAL_MS = 3000;

export enum CopyAiChatImageStatus {
  IDLE = 'idle',
  COPYING = 'copying',
  COPIED = 'copied',
  FAILED = 'failed',
}

export interface UseCopyAiChatImageParams {
  hashedId: string;
  source: AiChatCopyImageSource;
}

export interface UseCopyAiChatImage {
  canCopyImage: boolean;
  copyStatus: CopyAiChatImageStatus;
  copyImage: VoidFunction;
}
